import { gql } from "@apollo/client";
import { PROFILE_ENTITY_FIELDS } from "graphql/fragments";

const GET_SQUAD_DYNAMICS = gql`
  ${PROFILE_ENTITY_FIELDS}
  query teamDynamics($teamId: ID!, $filters: TeamDynamicsFilter!) {
    teamDynamics(teamId: $teamId, filters: $filters) {
      evaluatorProfile {
        ...ProfileEntityFields
      }
      evaluatedProfile {
        ...ProfileEntityFields
      }
      answer
      question
    }
  }
`;

export { GET_SQUAD_DYNAMICS };
